// src/lib/native.ts — Capacitor device features behind a web-safe façade.
//
// The same code runs on the web and inside the iOS/Android shell. On the web the
// camera falls back to a file picker and geolocation to the browser API, so nothing
// here ever throws just because it is running in a browser tab.

import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Geolocation } from '@capacitor/geolocation';

export const isNative = () => Capacitor.isNativePlatform();

/** Returns a data URL of the captured photo, or null if the user cancelled. */
export async function takePhoto(): Promise<string | null> {
  try {
    const shot = await Camera.getPhoto({ quality: 70, allowEditing: false, resultType: CameraResultType.DataUrl, source: isNative() ? CameraSource.Prompt : CameraSource.Photos, width: 1600 });
    return shot.dataUrl ?? null;
  } catch {
    return null;
  }
}

/** Best-effort coordinates for geotagging evidence. Never blocks the flow. */
export async function currentPosition(): Promise<{ latitude: number; longitude: number } | null> {
  try {
    const p = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 6000 });
    return { latitude: p.coords.latitude, longitude: p.coords.longitude };
  } catch {
    return null;
  }
}
